import { Fragment } from 'react';
import PageHeader from '../../../layout/shared/page-header';
import { menuRoutes } from '../../../router/menu';
import CallClassificationsPage from './CallClassificationsPage';

const CallClassificationsWrapper = () => {
    return (
        <Fragment>
            <PageHeader
                title="Tipificaciones de llamadas"
                breadcrumb={[
                    { name: 'Ventas' },
                    { name: 'Gestión de campañas' },
                    { name: 'Tipificaciones de llamadas', href: menuRoutes.calls.path + menuRoutes.calls.callClassifications },
                ]}
            />
            <CallClassificationsPage />
        </Fragment>
    );
};

export default CallClassificationsWrapper;
